import appPlugin from '@backstage/plugin-app';
import { AlertApiForwarder } from '@backstage/core-app-api';
import { alertApiRef } from '@backstage/core-plugin-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { DebouncedAlertApi } from '../../apis/DebouncedAlertApi';

export const debouncedAlertsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    appPlugin.getExtension('api:app/alert').override({
      params: defineParams =>
        defineParams({
          api: alertApiRef,
          deps: {},
          factory: () => new DebouncedAlertApi(new AlertApiForwarder()),
        }),
    }),
  ],
});
